import moment from "moment";
import { icons } from "../../../assets/icons";
import { displayDateFormat, switchLabel, hasAnyChildInRework } from "../../../utils/helpers";

export const l1Columns = ({
  extraColumns,
  approveRequestHandler,
  editApprovalHandler,
  rejectRequestHandler,
  inBetweenColumns,
  userActiveLevel,
  decisionStatusMap = {}, // Track decision status per sub-voucher
}) => [
  ...extraColumns,
  {
    Header: "Submit On",
    accessor: "submittedOn",
    Cell: (props) => {
      if (!props?.row?.original?.submittedOn) {
        return "-";
      }
      return (
        <div>
          {moment(
            props?.row?.original?.submittedOn).format(displayDateFormat)}
          {/* {props?.row?.original?.submittedOn || ""} */}
        </div>
      );
    },
  },
  { 
    Header: "Requested Amount (₹)", 
    accessor: "amount",
    Cell: (rowData) => {
      const value = rowData?.row?.original?.amount;
      let amount;
      if(typeof value == "string"){
        amount = Number(value).toFixed(2);
      } else {
        amount = value
      }
      return amount ? Number(amount).toFixed(2) : "-";
    },
  },
  ...inBetweenColumns,
  {
    Header: "Pending",
    accessor: "pendingAmount",
    Cell: (props) => {
      // debugger
      const value = props?.row?.original?.pendingAmount;
      if (!value) {
        return "-";
      }
      return <div className={"text-[var(--pendingYellow)]"}>{value ? Number(value).toFixed(2) : "-"}</div>;
    },
  },
  {
    Header: "Actions",
    accessor: "actions",
    Cell: ({ row }) => {
      let editAmount = row?.original?.l3AmountApproved || row?.original?.l2AmountApproved || row?.original?.l1AmountApproved || row?.original?.amount || "";
      const hasDecision = decisionStatusMap[row?.original?.id] === "Approved" || decisionStatusMap[row?.original?.id] === "Rejected";
      const actionsDisabled = hasAnyChildInRework(row?.original, userActiveLevel);

      return (
        <div className="flex items-center gap-x-4">
          {/* Show decision status badge if decision is made */}
          {hasDecision && (
            <div className={`text-sm font-medium ${
              decisionStatusMap[row?.original?.id] === "Approved"
                ? "text-[var(--successGreen)]"
                : "text-[var(--textRed)]"
            }`}>
              {decisionStatusMap[row?.original?.id]} (saved)
            </div>
          )}
          {!row?.original?.storeName ? (
            <img
              src={icons.editIcon}
              alt="edit icon"
              className={actionsDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}
              onClick={actionsDisabled ? undefined : () => {
                const ids = [];
                let amountData = row?.original?.amount
                if (row.original.documents) {
                  row.original.documents.forEach((row) => {
                    row.pendingDocs.forEach((row) => {
                      // row?.subHeadDocumentResponseList?.forEach((row) => {
                        // row?.document.forEach((row) => {
                          ids.push({
                            id: row?.id,
                            approvedAmount: row?.dataModalAttributeSet?.find(
                              (item) => item.metadataTechnicalName == switchLabel(userActiveLevel)
                            )?.attributeValue,
                            previousAm: row?.dataModalAttributeSet?.find(
                              (item) => item.metadataTechnicalName == switchLabel(userActiveLevel)
                            )?.attributeValue,

                            // approvedAmount: editAmount,
                            totalAmount: amountData,
                            // editAmount: editAmount
                          });
                        // });
                      // });
                    });
                  });
                }

                if (row?.original?.pendingDocs) {
                  row.original?.pendingDocs.forEach((row) => {
                    // row?.subHeadDocumentResponseList?.forEach((row) => {
                      // row?.document.forEach((row) => {
                        ids.push({
                          id: row?.id,
                          approvedAmount: row?.dataModalAttributeSet?.find(
                            (item) => item.metadataTechnicalName == switchLabel(userActiveLevel)
                          )?.attributeValue,
                          previousAm: row?.dataModalAttributeSet?.find(
                            (item) => item.metadataTechnicalName == switchLabel(userActiveLevel)
                          )?.attributeValue,
                          // approvedAmount: editAmount,
                          totalAmount: amountData,
                          // editAmount: editAmount
                        });
                      // });
                    // });
                  });
                }
                
                editApprovalHandler(ids, ids);
              }}
            />
          ) : null}
          {!hasDecision && (
            <img
              src={icons.squareTickIcon}
              alt="accept icon"
              className={actionsDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}
              onClick={actionsDisabled ? undefined : () => {
              const ids = [];
              if (row?.original?.documents) {
                row?.original?.documents?.forEach((row) => {
                  row?.pendingDocs?.forEach((row) => {
                    // row?.subHeadDocumentResponseList?.forEach((row) => {
                      // row?.document?.forEach((row) => {
                        ids.push({
                          id: row?.id,
                          approvedAmount: row?.dataModalAttributeSet?.find(
                            (item) => item.metadataTechnicalName == switchLabel(userActiveLevel)
                            )?.attributeValue,
                          // approvedAmount: editAmount,
                          editAmount: editAmount
                        });
                      // });
                    // });
                  });
                });
              }


              if (row?.original?.pendingDocs) {
                row.original?.pendingDocs?.forEach((row) => {
                  // row?.subHeadDocumentResponseList?.forEach((row) => {
                    // row?.document.forEach((row) => {
                      ids.push({
                        id: row?.id,
                        approvedAmount: row?.dataModalAttributeSet?.find(
                          (item) => item.metadataTechnicalName == switchLabel(userActiveLevel)
                          )?.attributeValue,
                        // approvedAmount: editAmount,
                        editAmount: editAmount
                      });
                    // });
                  // });
                });
              }

              const parentVoucherId = row?.original?.id ?? row?.original?.vid;
              approveRequestHandler(ids, "", false, parentVoucherId); // save + sendAll so parent voucher moves out of Pending
            }}
            />
          )}
          {!hasDecision && (
            <img
              src={icons.squareTimesIcon}
              alt="reject icon"
              className={actionsDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}
              onClick={actionsDisabled ? undefined : () => {
              const ids = [];
              if (row?.original?.documents) {
                row?.original?.documents?.forEach((row) => {
                  row?.pendingDocs?.forEach((row) => {
                    // row?.subHeadDocumentResponseList?.forEach((row) => {
                      // row?.document?.forEach((row) => {
                        ids.push(
                          row?.id,
                        );
                      // });
                    // });
                  });
                });
              }


              if (row?.original?.pendingDocs) {
                row.original?.pendingDocs?.forEach((row) => {
                  // row?.subHeadDocumentResponseList?.forEach((row) => {
                    // row?.document.forEach((row) => {
                      ids.push(
                        row?.id,
                      );
                    // });
                  // });
                });
              }

              rejectRequestHandler(ids);
            }}
            />
          )}
        </div>
      );
    },
  },
];
